import CodeBlooded from "../images/code_blooded.svg";
import CodeBender from "../images/code_bender.svg";
import Committer from "../images/committer.svg";
import LeadDisruptor from "../images/lead_disruptor.svg";

const getUserAvatar = (points) => {
  if (points <= 300) return CodeBlooded;
  if (points <= 500) return CodeBender;
  if (points <= 800) return Committer;
  if (points > 800) return LeadDisruptor;
};

export default getUserAvatar;
